export default __webpack_public_path__ + "static/media/comms_active.414c1413.svg";